const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stripUnit(value, unitReturn) {
    if (typeof value !== "string")
        return unitReturn ? [value, undefined] : value;
    const matchedValue = value.match(cssRegex);
    if (unitReturn) {
        if (matchedValue)
            return [parseFloat(value), matchedValue[2]];
        return [value, undefined];
    }
    if (matchedValue)
        return parseFloat(value);
    return value;
}
export const rem = (val, baseFontSize = 16) => {
    const [dimension, unit] = stripUnit(val, true);
    if (unit != "px") {
        throw new Error("Please provide px unit");
    }
    return `${dimension / baseFontSize}rem`;
};
export const hideVisually = () => `
   border: 0;
   clip: rect(0 0 0 0);
   height: 1px;
   margin: -1px;
   overflow: hidden;
   padding: 0;
   position: absolute;
   white-space: nowrap;
   width: 1px;
`;
//# sourceMappingURL=polished.js.map